export const adminNavigationItems = [
  { label: 'Manage members', icon: 'Users', route: { name: 'admin-members' } },
  { label: 'Manage teams', icon: 'UsersRound', route: { name: 'admin-teams' } },
  { label: 'Manage species', icon: 'Fish', route: { name: 'admin-species' } },
  { label: 'Manage comps', icon: 'Trophy', route: { name: 'admin-competitions' } },
  { label: 'Scorecard reviews', icon: 'FileCheck2', route: { name: 'admin-catch-reviews' } },
  { label: 'Member leaderboard', icon: 'Users', route: { name: 'admin-member-leaderboard' } },
  { label: 'Species leaderboard', icon: 'BarChart3', route: { name: 'admin-species-leaderboard' } },
  { label: 'Prize templates', icon: 'Award', route: { name: 'admin-prize-templates' } },
  { label: 'Announcements', icon: 'Newspaper', route: { name: 'admin-announcements' } },
  { label: 'Manage sponsors', icon: 'Handshake', route: { name: 'admin-sponsors' } },
  { label: 'Analytics', icon: 'Gauge', route: { name: 'admin-analytics' } },
  { label: 'Photo service', icon: 'Images', route: { name: 'admin-unsorted-uploads' } },
  { label: 'Dashboard', icon: 'LayoutDashboard', route: { name: 'admin-dashboard' } },
];
